import {
  stockEventMatchesBusiness,
  type BusinessScopedStockEvent,
} from './stockEventBusinessScope.js';

export interface TraceBusinessMaster {
  id: string;
  tenant_id?: string | null;
  archived_at?: string | null;
}

export interface TraceSearchBusinessScope {
  businessId: string;
  allowLegacyUnscoped: boolean;
}

export function resolveTraceSearchBusinessScope(input: {
  businesses: readonly TraceBusinessMaster[];
  tenantId: string | null;
  activeBusinessId: string | null;
  businessesLoading: boolean;
  businessesError: boolean;
}): TraceSearchBusinessScope | null {
  const businessId = input.activeBusinessId?.trim() || null;
  if (!businessId) return null;

  const activeIds = new Set(
    input.businesses
      .filter((business) => !business.archived_at)
      .filter((business) =>
        !business.tenant_id || business.tenant_id === input.tenantId
      )
      .map((business) => business.id.trim())
      .filter(Boolean),
  );
  return {
    businessId,
    allowLegacyUnscoped:
      !input.businessesLoading
      && !input.businessesError
      && activeIds.size === 1
      && activeIds.has(businessId),
  };
}

export function traceRowMatchesBusiness(
  row: BusinessScopedStockEvent,
  scope: TraceSearchBusinessScope | null,
): boolean {
  return scope !== null
    && stockEventMatchesBusiness(
      row,
      scope.businessId,
      scope.allowLegacyUnscoped,
    );
}
